import useBaseAPI from './useBaseAPI';

const useCustomerAPI = () => {
  const { client, isLoading, apiURL } = useBaseAPI();


  const getCustomers = async () => {
    try {
      const response = await client('get', '/customer/');
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getSapCustomers = async () => {
    try {
      const response = await client('get', '/customer/sap/');
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const addCustomer = async (payload) => {
    try {
      const response = await client('post', '/customer', payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const updateCustomer = async (customer, payload) => {
    try {
      const response = await client('post', `/customer/${customer}`, payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getCustomer = async (customerId) => {
    try {
      const response = await client('get', `/customer/${customerId}`);
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const deleteCustomer = async (customerId) => {
    try {
      const response = await client('delete', `/customer/${customerId}`);
      return response?.success;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const downloadAuditReport = async (startDate, endDate) => {
    try {
      const response = await client(
        'get',
        `/audit/report?startDate=${startDate}&endDate=${endDate}`,
        null,
        {
          baseUrl: apiURL,
          accept: 'text/csv',
        },
      );
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    getCustomers,
    addCustomer,
    updateCustomer,
    getCustomer,
    deleteCustomer,
    getSapCustomers,
    downloadAuditReport,
    isLoading,
  };
};

export default useCustomerAPI;
